import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button} from "reactstrap";
import ReactTable from "react-table";
import {Card, CardContent} from "@material-ui/core";
import moment from "moment";
import EditableNotesCell from "../Parts/EditableNotesCell";

export default class AccountSignups extends Framework.Components.Collection {
	constructor(props) {
		const model = new API.BuildClass(Types.Admins_Accounts._name, API.RequestType.READ_ALL);
		model.sort = 'created';
		model.order = 'desc';
		super(props, model);
		this.state.limit = 16;
		this.state.dismissingSignup = null;
		this.state.signupError = null;
	}

	dismissSignup = async (accountId) => {
		this.setState({dismissingSignup: accountId, signupError: null});
		try {
			const model = new API.BuildClass(Types.Admins_Accounts._name, 'POST_DISMISS_SIGNUP');
			model.object.pkey = accountId;
			const response = await model.submit(null, 'POST_DISMISS_SIGNUP', true);
			if (!model.successful || !response || !response.dismissed) throw new Error('Dismissal failed');
			this.setState(previousState => ({
				data: previousState.data.map(account => account.pkey === accountId ? {...account, admin_signup_unread: false} : account)
			}));
			window.dispatchEvent(new Event('signup-notifications-changed'));
		} catch (error) {
			this.setState({signupError: 'Unable to dismiss this signup. Please try again.'});
		} finally {
			this.setState({dismissingSignup: null});
		}
	};

	saveNotes = async (rowId, notes) => {
		const notesModel = new API.BuildClass(Types.Admins_Accounts._name, 'POST_NOTES');
		notesModel.object.pkey = rowId;
		notesModel.object.admin_notes = notes;
		await notesModel.submit(null, 'POST_NOTES');
		this.setState(previousState => ({
			data: previousState.data.map(row => row.pkey === rowId ? {...row, admin_notes: notes} : row)
		}));
	};

	render() {
		const {data, pages, limit,  loading} = this.state;
		return (
			<Card>
				<CardContent>
					<div className="box-body">
						<div className="table-bar">
							<div className="d-flex">
								{this.renderSearch('New Customer Signups')}
								<div className="ml-auto refresh">
									<Button color="secondary" onClick={this.reloadTable}>
										<i className="fa fa-refresh"/>
									</Button>
								</div>
							</div>
						</div>
						{this.state.signupError && <p className="text-danger" role="alert">{this.state.signupError}</p>}
						<ReactTable
							key={this.state.key}
							columns={[
								{
									Header: "New Signup",
									id: "admin_signup_unread",
									width: 160,
									sortable: false,
									Cell: cellInfo => Number(cellInfo.original.admin_signup_unread) === 1 ? (
										<div>
											<span className="badge badge-info mr-2">New</span>
											<Button size="sm" color="secondary" disabled={this.state.dismissingSignup !== null}
												onClick={() => this.dismissSignup(cellInfo.original.pkey)}
												aria-label={`Dismiss new signup for account ${cellInfo.original.pkey}`}>Dismiss</Button>
										</div>
									) : null
								},
								{
									Header: "Admin Notes",
									accessor: "admin_notes",
									minWidth: 280,
									sortable: false,
									Cell: cellInfo => (
										<EditableNotesCell
											key={cellInfo.original.pkey}
											rowId={cellInfo.original.pkey}
											originalValue={cellInfo.original.admin_notes}
											onSave={this.saveNotes}
										/>
									)
								},
								{
									Header: "Created",
									id: "created",
									width: 160,
									accessor: account => account.created ? moment(account.created).local().format("MM/DD/YYYY h:mm A") : '-'
								},
								{
									Header: "Account",
									id: "pkey",
									width: 90,
									accessor: account => account.pkey
								},
								{
									Header: "Company",
									id: "name_company",
									accessor: account => account.name_company || '-'
								},
								{
									Header: "Legal Name",
									id: "name_legal",
									accessor: account => account.name_legal || '-'
								},
								{
									Header: "Owner",
									id: "name_first",
									accessor: account => [account.name_first, account.name_last].filter(Boolean).join(' ') || '-'
								},
								{
									Header: "Email",
									id: "email",
									accessor: account => account.email || '-'
								},
								{
									Header: "Phone",
									id: "number",
									accessor: account => account.number || '-'
								},
								{
									Header: "Mobile",
									id: "mobile",
									accessor: account => account.mobile || '-'
								},
								{
									Header: "Address",
									id: "street_1",
									width: 240,
									accessor: account => [
										account.street_1,
										account.street_2,
										[account.city, account.state].filter(Boolean).join(', '),
										account.zip
									].filter(Boolean).join(' ') || '-'
								},
								{
									Header: "Locations",
									id: "location_names",
									sortable: false,
									accessor: account => account.location_names || '-'
								},
								{
									Header: "FFL Number(s)",
									id: "ffl_numbers",
									sortable: false,
									accessor: account => account.ffl_numbers || '-'
								},
								{
									Header: "Location Count",
									id: "location_count",
									width: 110,
									sortable: false,
									accessor: account => account.location_count
								},
								{
									Header: "Active Users",
									id: "active_user_count",
									width: 100,
									sortable: false,
									accessor: account => account.active_user_count
								},
								{
									Header: "Current Plans",
									id: "subscription_names",
									sortable: false,
									accessor: account => account.subscription_names || '-'
								},
								{
									Header: "Billing",
									id: "has_billing",
									width: 95,
									accessor: account => account.failed_billing ? 'Failed' : (account.has_billing ? 'Active' : 'Not Set')
								},
								{
									Header: "Last Login",
									id: "last_logged_in",
									width: 160,
									accessor: account => account.last_logged_in ? moment(account.last_logged_in).local().format("MM/DD/YYYY h:mm A") : '-'
								}
							]}
							manual
							data={data}
							pages={pages}
							loading={loading}
							loadingText="Requesting Data"
							onFetchData={this.fetchData}
							expanderDefaults={{
								sortable: true,
								resizable: true,
								filterable: false,
								width: undefined
							}}
							onExpandedChange={this.onExpandedChange}
							defaultSorted={[
								{
									id: this.model.sort,
									desc: this.model.order === 'desc'
								}
							]}
							showPagination={pages > 1}
							defaultPageSize={limit}
							getTrProps={(state, rowInfo) => rowInfo && Number(rowInfo.original.admin_signup_unread) === 1 ? {
								style: {backgroundColor: '#fff3cd', color: '#212529'}
							} : {}}
							className="-striped -highlight"
						/>
					</div>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>
				</CardContent>
			</Card>
		);
	}
}
